import styled from 'styled-components';

export default styled.div`
  white-space: pre-wrap;
  position: relative;

  & > * .leftAlignmentStyles {
    text-align: left;
  }
  
  & > * .rightAlignmentStyles {
    text-align: right;
  }

  & > * .centerAlignmentStyles {
    text-align: center;
  }

  & > * .justifyAlignmentStyles {
    text-align: justify;
  }

  & > * .quoteStyles {
    color: rgb(153, 153, 153);
    text-align: center;
    font-style: italic;
  }
 
  & > * ul {
    list-style: none;
    list-style-type: 'square'
  }

  & > * ul li{
    display: flex;
    align-items: center;
    
  }

  & > * ul li::before {
    content: "•";
    width: 1em; 
    margin-left: -1em;
    position: relative;
    ${props => props.bulletStyling ? props.bulletStyling : ''} 
  }

`;
